import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators,
  AbstractControl
} from '@angular/forms';
import { Entry } from 'contentful';

@Component({
  selector: 'app-complete-profile',
  templateUrl: './complete-profile.component.html',
  styleUrls: ['./complete-profile.component.scss']
})
export class CompleteProfileComponent implements OnInit {
  @Input() public content: Entry<any>;
  @Input() public globalContent: Entry<any>;
  @Output() public completeProfile = new EventEmitter<boolean>();
  public completeProfileForm = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    newsletter: new FormControl(false, [Validators.required])
  });

  constructor() {}

  ngOnInit() {}

  get firstName() {
    return this.completeProfileForm.get('firstName');
  }

  get lastName() {
    return this.completeProfileForm.get('lastName');
  }

  get newsletter() {
    return this.completeProfileForm.get('newsletter');
  }

  hasError(formControl: AbstractControl, validator: string) {
    return (
      formControl.touched &&
      formControl.dirty &&
      formControl.hasError(validator)
    );
  }

  submit() {
    Object.values(this.completeProfileForm.controls).forEach(control => {
      control.markAsDirty();
      control.markAsTouched();
      control.updateValueAndValidity();
    });

    if (this.completeProfileForm.valid) {
      this.completeProfile.emit(this.completeProfileForm.value);
    }
  }
}
